// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"s0-z"};